import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { TableLazyLoad } from '../models/table-lazy-load';

@Injectable()
export class TableEventsSourceService<Filter> {
  private readonly lazyLoadSource$ = new Subject<TableLazyLoad<Filter>>();

  public get lazyLoad$(): Observable<TableLazyLoad<Filter>> {
    return this.lazyLoadSource$.asObservable();
  }

  public notifyLazyLoad(lazyLoad: TableLazyLoad<Filter>): void {
    this.lazyLoadSource$.next(lazyLoad);
  }
}
